{
  "PAGINATION_FOOTER": {
    "SHOWING": "Mostrando {startItem} - {endItem} di {totalItems} elementi",
    "CURRENT_PAGE_INFO": "{currentPage} di {totalPages} pagine"
  },
  "COMBOBOX": {
    "PLACEHOLDER": "Seleziona un'opzione...",
    "EMPTY_SEARCH_RESULTS": "Nessun elemento trovato per il termine di ricerca `{searchTerm}`",
    "EMPTY_STATE": "Nessun risultato trovato.",
    "SEARCH_PLACEHOLDER": "Cerca...",
    "MORE": "+{count} altre"
  },
  "DROPDOWN_MENU": {
    "SEARCH_PLACEHOLDER": "Cerca...",
    "EMPTY_STATE": "Nessun risultato trovato.",
    "SEARCHING": "Ricerca..."
  },
  "DIALOG": {
    "BUTTONS": {
      "CANCEL": "Annulla",
      "CONFIRM": "Conferma"
    }
  },
  "PHONE_INPUT": {
    "SEARCH_PLACEHOLDER": "Cerca Paese",
    "ERROR": "Il numero di telefono deve essere vuoto o in formato E.164",
    "DIAL_CODE_ERROR": "Seleziona un codice di chiamata dalla lista"
  },
  "THUMBNAIL": {
    "AUTHOR": {
      "NOT_AVAILABLE": "Autore non disponibile"
    }
  },
  "BREADCRUMB": {
    "ARIA_LABEL": "Breadcrumb"
  },
  "SWITCH": {
    "TOGGLE": "Toggle switch"
  },
  "LABEL": {
    "TAG_BUTTON": "tag"
  },
  "FEATURE_SPOTLIGHT": {
    "LEARN_MORE": "Scopri di più",
    "WATCH_VIDEO": "Guarda video"
  },
  "DURATION_INPUT": {
    "MINUTES": "Minuti",
    "HOURS": "Ore",
    "DAYS": "Giorni",
    "PLACEHOLDER": "Inserisci durata"
  },
  "CHANNEL_SELECTOR": {
    "COMING_SOON": "Coming Soon!"
  },
  "SLASH_COMMANDS": {
    "HEADING_1": "Heading 1",
    "HEADING_2": "Heading 2",
    "HEADING_3": "Heading 3",
    "BOLD": "Bold",
    "ITALIC": "Italic",
    "STRIKETHROUGH": "Strikethrough",
    "CODE": "Code",
    "BULLET_LIST": "Bullet List",
    "ORDERED_LIST": "Ordered List",
    "TABLE": "Table",
    "IMAGE": "Image"
  }
}
